export type RouteConfig = {
  path: string;
  showSearch: boolean;
  showHeaderInfo: boolean;
  headerType?:
    | "claim"
    | "rre"
    | "file"
    | "msa"
    | "costProjection"
    | "fm-overview"
    | "arScreening"
    | "client"
    | "lien-overview"
    | "lien-detail"
    | "lien-directory"
    | "document-management"
    | "audit"
    | "consulting"
    | "task"
    | "finance-filter";
};

// this file is used to define what we want to show in the header for each route

/*
each route is an object with the following properties:
  path: string - the path of the route
  showSearch: boolean - whether to show the search bar
  showHeaderInfo: boolean - whether to show the header info pill
  headerType: string - the type of header to show (see HeaderUtils.ts)
*/
export const ROUTE_CONFIG: RouteConfig[] = [
  // Claims routes
  {
    path: "/section-111/claims",
    showSearch: true,
    showHeaderInfo: false,
  },
  {
    path: "/section-111/claims/:claimId/:workspace",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "claim",
  },

  // Future Medical
  {
    path: "/future-medical/overview",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "fm-overview",
  },

  // LCP
  {
    path: "/future-medical/lcp",
    showSearch: true,
    showHeaderInfo: false,
  },
  {
    path: "/future-medical/lcp/:lcpId/metadoc",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "costProjection",
  },
  {
    path: "/future-medical/lcp/:lcpId/metadoc/:metadocId",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "costProjection",
  },
  {
    path: "/future-medical/lcp/:id/",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "costProjection",
  },
  {
    path: "/future-medical/lcp/:id/:workspace",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "costProjection",
  },

  // MCP
  {
    path: "/future-medical/mcp",
    showSearch: true,
    showHeaderInfo: false,
  },
  {
    path: "/future-medical/mcp/:mcpId/metadoc",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "costProjection",
  },
  {
    path: "/future-medical/mcp/:mcpId/metadoc/:metadocId",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "costProjection",
  },
  {
    path: "/future-medical/mcp/:id/",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "costProjection",
  },
  {
    path: "/future-medical/mcp/:id/:workspace",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "costProjection",
  },

  // Amended Review
  {
    path: "/future-medical/amended-review",
    showSearch: true,
    showHeaderInfo: false,
  },
  {
    path: "/future-medical/amended-review/:msaId/metadoc",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "msa",
  },
  {
    path: "/future-medical/amended-review/:msaId/metadoc/:metadocId",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "msa",
  },
  {
    path: "/future-medical/amended-review/:id",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "msa",
  },
  {
    path: "/future-medical/amended-review/:id/:workspace",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "msa",
  },

  // MSA
  {
    path: "/future-medical/msa",
    showSearch: true,
    showHeaderInfo: false,
  },
  {
    path: "/future-medical/msa/:msaId/metadoc",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "msa",
  },
  {
    path: "/future-medical/msa/:msaId/metadoc/:metadocId",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "msa",
  },
  {
    path: "/future-medical/msa/:id/",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "msa",
  },
  {
    path: "/future-medical/msa/:id/:workspace",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "msa",
  },

  // AR Screening
  {
    path: "/future-medical/ar-screening",
    showSearch: true,
    showHeaderInfo: false,
  },
  {
    path: "/future-medical/ar-screening/:reviewId/metadoc",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "arScreening",
  },
  {
    path: "/future-medical/ar-screening/:reviewId/metadoc/:metadocId",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "arScreening",
  },
  {
    path: "/future-medical/ar-screening/:id/",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "arScreening",
  },
  {
    path: "/future-medical/ar-screening/:id/:workspace",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "arScreening",
  },

  // File routes
  {
    path: "/operations/files/:fileId/metadoc",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "file",
  },
  {
    path: "/operations/files/:fileId/metadoc/:metadocId",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "file",
  },
  {
    path: "/operations/files/new",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "file",
  },
  {
    path: "/operations/files/:fileId/edit",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "file",
  },
  {
    path: "/operations/files/:fileId/edit/:tab",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "file",
  },
  {
    path: "/operations/files/:fileId",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "file",
  },
  {
    path: "/operations/files",
    showSearch: true,
    showHeaderInfo: false,
  },
  {
    path: "/operations/recently-viewed",
    showSearch: true,
    showHeaderInfo: false,
  },

  // Intake routes
  {
    path: "/operations/intake",
    showSearch: true,
    showHeaderInfo: false,
  },

  // Lien routes
  {
    path: "/liens/:lienFileId/metadoc",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "lien-overview",
  },
  {
    path: "/liens/:lienFileId/overview",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "lien-overview",
  },
  {
    path: "/liens/:lienFileId/invoice",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "lien-overview",
  },
  {
    path: "/liens/:lienFileId/query",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "lien-overview",
  },
  {
    path: "/liens/:lienFileId/lien/:lienId",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "lien-detail",
  },
  {
    path: "/liens/:lienFileId/lien/:lienId/:lienSection",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "lien-detail",
  },
  {
    path: "/liens/:lienFileId/directory",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "lien-overview",
  },
  {
    path: "/liens/:lienFileId/notes",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "lien-overview",
  },

  // Document Management routes
  {
    path: "/document-management/:documentManagementFileId/metadoc",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "document-management",
  },
  {
    path: "/document-management/:documentManagementFileId/metadoc/:metadocId",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "document-management",
  },
  {
    path: "/document-management/:documentManagementFileId/:dmSection",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "document-management",
  },

  // Operations routes
  {
    path: "/operations/clients",
    showSearch: true,
    showHeaderInfo: false,
  },
  {
    path: "/operations/employers",
    showSearch: true,
    showHeaderInfo: false,
  },
  {
    path: "/operations/insurers",
    showSearch: true,
    showHeaderInfo: false,
  },
  {
    path: "/operations/tpas",
    showSearch: true,
    showHeaderInfo: false,
  },
  {
    path: "/operations/adjusters",
    showSearch: true,
    showHeaderInfo: false,
  },
  {
    path: "/operations/claimants",
    showSearch: true,
    showHeaderInfo: false,
  },

  // Downloads routes
  {
    path: "/downloads",
    showSearch: true,
    showHeaderInfo: false,
  },

  // RRE routes
  {
    path: "/section-111/rres",
    showSearch: true,
    showHeaderInfo: false,
  },
  {
    path: "/section-111/rres/:rreId/:workspace",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "rre",
  },

  // Audit routes
  {
    path: "/audit/:id",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "audit",
  },

  // Consulting routes
  {
    path: "/consulting/:id",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "consulting",
  },

  // Finance routes
  {
    path: "/reporting/finance",
    showSearch: false,
    showHeaderInfo: true,
    headerType: "finance-filter",
  },

  // Default routes
  {
    path: "/",
    showSearch: true,
    showHeaderInfo: false,
  },
  {
    path: "/your-tasks",
    showSearch: true,
    showHeaderInfo: true,
    headerType: "task",
  },
];
